import React, {Component} from 'react';
import PercentChart from './PercentChart';

export default class NPL extends Component {
  render() {
    return <PercentChart up title='NPL' upDownPercent='14.30%' percent='3.10%' />;
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/PercentChart/NPL.js